import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useSearchDialog } from "@/components/common/GNB/hooks";
import useGNBMenu from "@/components/common/GNB/hooks/useGNBMenu";
import useGNBHandler from "@/components/common/GNB/useGNBHandler";
import { SearchRecommendFullscreenDialog } from "@/components/SearchRecommend/SearchRecommendFullscreenDialog";
import { GNBSideSheet } from "@/components/SideSheets/GNBSideSheet";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { LOGIN_PAGE, MYPAGE_PAGE, PASSES_LANDING, PRODUCT_SEARCH_PAGE, REGISTRATION_PAGE, SHOP_CART_PAGE, SHOP_CHECKOUT_PAGE } from "@/settings/constant";
import { useRouter } from "next/router";
import { useHomeSwitchStore } from "src/store/homeSwitch.store";
import DesktopNav from "./components/nav/DesktopNav";
import MobileNav from "./components/nav/MobileNav";
import TabletNav from "./components/nav/TabletNav";
import GNBSubNavContainer from "./GNBSubNavContainer";
// GNBSubNav를 숨길 페이지 경로
const HIDDEN_SUBNAV_PATHS = [
    PRODUCT_SEARCH_PAGE,
    PASSES_LANDING,
    SHOP_CART_PAGE,
    SHOP_CHECKOUT_PAGE,
    LOGIN_PAGE,
    REGISTRATION_PAGE,
    MYPAGE_PAGE
];
const MarketGNB = ()=>{
    const { pathname  } = useRouter();
    const { handleSideMenu , handleCategoryHover , isOpenSideMenu  } = useGNBHandler();
    const search = useSearchDialog();
    const { setHomeId , homeId  } = useHomeSwitchStore();
    // GNB 메뉴 상태 관리 (homeType, 토글 핸들러, 로그인 상태)
    const { homeType , handleToggle , isLoggedIn , gnbMenuQuery  } = useGNBMenu();
    const { data: gnbMenuData  } = gnbMenuQuery;
    // 홈 탭 변경 핸들러 (homeNavigation 클릭 시)
    // homeId를 store에 저장하면 useGetHomeSection이 자동으로 해당 홈 데이터를 조회
    const handleHomeChange = (homeId)=>{
        setHomeId(homeId);
    };
    const showSubNav = !HIDDEN_SUBNAV_PATHS.some((path)=>pathname.startsWith(path));
    const { isMobile  } = useWindowDimensions() // 1080px 미만
    ;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("header", {
                className: "sticky top-0 z-[800] bg-white",
                children: [
                    /*#__PURE__*/ _jsx(DesktopNav, {
                        homeType: homeType,
                        onToggle: handleToggle,
                        isLoggedIn: isLoggedIn,
                        gnbBanner: gnbMenuData === null || gnbMenuData === void 0 ? void 0 : gnbMenuData.gnbBanner
                    }),
                    /*#__PURE__*/ _jsx(TabletNav, {
                        homeType: homeType,
                        onToggle: handleToggle,
                        onMenuClick: handleSideMenu,
                        gnbBanner: gnbMenuData === null || gnbMenuData === void 0 ? void 0 : gnbMenuData.gnbBanner
                    }),
                    /*#__PURE__*/ _jsx(MobileNav, {
                        onSearchClick: search.open,
                        onMenuClick: handleSideMenu
                    }),
                    showSubNav && /*#__PURE__*/ _jsx(GNBSubNavContainer, {
                        gnbMenuData: gnbMenuData,
                        selectedHomeId: homeId || (gnbMenuData === null || gnbMenuData === void 0 ? void 0 : gnbMenuData.homeId) || "",
                        onHomeChange: handleHomeChange,
                        onCategoryHover: handleCategoryHover,
                        isCategoryMenuOpen: isOpenSideMenu
                    }),
                    /*#__PURE__*/ _jsx(GNBSideSheet, {})
                ]
            }),
            isMobile && /*#__PURE__*/ _jsx(SearchRecommendFullscreenDialog, {})
        ]
    });
};
export default MarketGNB;
